{
  "name": "salesrun",
  "version": "5.101.5",
  "description": "",
  "scripts": {
    "db:update": "sr database update",
    "stubs": "sr development stubs",
    "analyze": "npx webpack-bundle-analyzer backend/QuoteBuilder.Web/wwwroot/app/stats.json",
    "test": "npm run ng-run-memory -- app:test --include=\"../../**/*.spec.ts\" --exclude=\"../../node_modules/**/*\" --exclude=\"../../react/**/*\"",
    "test:ci": "npm run ng-run-memory -- app:test-ci --include=\"../../**/*.spec.ts\" --exclude=\"../../node_modules/**/*\" --exclude=\"../../react/**/*\"",
    "ng": "node ./node_modules/@angular/cli/bin/ng",
    "ng-run-memory": "node --max_old_space_size=7000 ./node_modules/@angular/cli/bin/ng run",
    "build": "ng build login && ng build tenants && ng build support && ng build app",
    "build:prod": "ng build login --configuration production && ng build tenants --configuration production && ng build support --configuration production && ng build app --configuration production",
    "publish:backend": "npm run powershell -- ./build/backend.config.ps1 && dotnet restore && npm run powershell -- ./build/backend.build.ps1",
    "publish:frontend": "npm run powershell -- ./build/frontend.config.ps1 && npm ci --legacy-peer-deps && npm run build:prod && npm run powershell -- ./build/frontend.post-build.ps1",
    "publish": "npm run publish:backend && npm run publish:frontend && npm run powershell -- ./build/publish.ps1",
    "powershell": "pwsh -ExecutionPolicy ByPass -File",
    "//": "TODO: ESLINT: add automated lint fixes (with committing changes & cache) https://github.com/marketplace/actions/add-commit",
    "///": "TODO: ESLINT: use unstable_config_lookup_from_file flag to fix CLI linting",
    "lint": "npx eslint . --fix",
    "lint:ci": "npx eslint . --quiet",
    "lint:debug": "npx cross-env DEBUG=typescript-eslint:* npx eslint .",
    "pkg:clean": "(npx rimraf package-lock.json || exit 0) && (npx rimraf node_modules || exit 0)",
    "pkg:update": "npx npm-check-updates -u && npm i --save --save-exact tinymce@4.6.5 && npm i --save-dev --save-exact typescript@4.5.5 @types/quill@1.3.10 && npm run pkg:clean && npm i"
  },
  "author": "AIS Novations",
  "license": "ISC",
  "dependenciesComments": {
    "//": "!!WARN!! Update pkg:update script on any change here",
    "tinymce": "Tied to 4.6.5 because of breaking changes in new version",
    "typescript": "Tied to 4.5.5 until angular@14",
    "@types/quill": "Tied to 1.3.10 until update to quill@2"
  },
  "dependencies": {
    "@angular/animations": "19.2.18",
    "@angular/cdk": "13.3.9",
    "@angular/common": "19.2.18",
    "@angular/compiler": "19.2.18",
    "@angular/core": "19.2.18",
    "@angular/flex-layout": "13.0.0-beta.38",
    "@angular/forms": "19.2.18",
    "@angular/material": "13.3.9",
    "@angular/material-moment-adapter": "13.3.9",
    "@angular/platform-browser": "19.2.18",
    "@angular/platform-browser-dynamic": "19.2.18",
    "@angular/router": "19.2.18",
    "@auth0/angular-jwt": "5.2.0",
    "@microsoft/signalr": "9.0.6",
    "@ngrx/effects": "13.2.0",
    "@ngrx/store": "13.2.0",
    "@ngrx/store-devtools": "13.2.0",
    "@swimlane/ngx-datatable": "21.1.0",
    "@types/youtube": "0.1.2",
    "@vimeo/player": "2.30.1",
    "@viselect/vanilla": "3.9.0",
    "abort-signal-polyfill": "1.0.0",
    "angular-gridster2": "13.3.2",
    "angular-imask": "7.6.1",
    "angular-resizable-element": "7.0.2",
    "chart.js": "4.5.1",
    "core-js": "3.47.0",
    "deep-freeze": "0.0.1",
    "file-saver-es": "2.0.5",
    "keycode-js": "3.1.0",
    "lodash-es": "4.17.23",
    "moment": "2.30.1",
    "moment-timezone": "0.6.0",
    "ngrx-store-localstorage": "13.0.1",
    "ngrx-store-logger": "0.2.4",
    "ngx-infinite-scroll": "19.0.0",
    "ngx-quill": "16.2.1",
    "ngx-trim-directive": "3.0.1",
    "normalizr": "3.6.2",
    "pdfjs-dist": "5.4.296",
    "quill": "1.3.7",
    "recordrtc": "5.6.2",
    "rollbar": "2.26.5",
    "rxjs": "7.8.2",
    "safe-pipe": "3.0.4",
    "sort-any": "4.0.7",
    "swiper": "8.4.7",
    "tinymce": "4.9.11",
    "to-words": "4.9.0",
    "tslib": "2.8.1",
    "uuid": "13.0.0",
    "xregexp": "5.1.2",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-builders/custom-esbuild": "19.1.0",
    "@angular-builders/custom-webpack": "19.0.1",
    "@angular-eslint/builder": "19.8.1",
    "@angular-eslint/eslint-plugin": "19.8.1",
    "@angular-eslint/eslint-plugin-template": "19.8.1",
    "@angular-eslint/schematics": "19.8.1",
    "@angular-eslint/template-parser": "19.8.1",
    "@angular/build": "19.2.19",
    "@angular/cli": "19.2.19",
    "@angular/compiler-cli": "19.2.18",
    "@eslint/compat": "1.4.1",
    "@eslint/eslintrc": "3.3.3",
    "@eslint/js": "9.39.2",
    "@mdi/angular-material": "7.2.96",
    "@stylistic/eslint-plugin": "5.7.0",
    "@types/deep-freeze": "0.1.5",
    "@types/file-saver-es": "2.0.3",
    "@types/jasmine": "3.10.18",
    "@types/lodash-es": "4.17.12",
    "@types/node": "22.19.3",
    "@types/offscreencanvas": "2019.7.3",
    "@types/quill": "1.3.10",
    "@types/recordrtc": "5.6.15",
    "@types/tinymce": "4.6.9",
    "@types/webpack": "5.28.5",
    "chalk": "5.6.2",
    "esbuild": "0.27.2",
    "esbuild-plugin-browserslist": "2.0.0",
    "eslint": "9.39.2",
    "eslint-plugin-rxjs-x": "0.8.4",
    "file-loader": "6.2.0",
    "http-proxy": "1.18.1",
    "jasmine-auto-spies": "8.0.1",
    "jasmine-core": "4.6.1",
    "jasmine-marbles": "0.9.2",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "4.0.2",
    "karma-junit-reporter": "2.0.1",
    "karma-spec-reporter": "0.0.36",
    "localtunnel": "2.0.2",
    "ng-mocks": "14.15.0",
    "node-simple-router": "0.10.2",
    "pretty-error": "4.0.0",
    "sass-toolkit": "2.10.2",
    "ts-node": "10.9.2",
    "typescript": "5.8.3",
    "typescript-eslint": "8.48.1"
  }
}